import { DefaultModalConfig, GlobalReducerState } from './types';

const defaultModalConfig: DefaultModalConfig = { isOpened: false };

export const initialState: GlobalReducerState = {
  error: null,
  trainingRequiredModal: defaultModalConfig,
  acceptLeadsPassingModal: defaultModalConfig,
  submitOrderModal: {
    ...defaultModalConfig,
    // Modal should not be opened without an activity
    opportunityId: null,
    updateDetails: false,
  },
};
